import { render, staticRenderFns } from "./ListDivided.vue?vue&type=template&id=7b030f5f&"
import script from "./ListDivided.vue?vue&type=script&lang=ts&"
export * from "./ListDivided.vue?vue&type=script&lang=ts&"
import style0 from "./ListDivided.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports